import { render, staticRenderFns } from "./TemplateMailForm.vue?vue&type=template&id=2ca58b5e"
import script from "./TemplateMailForm.vue?vue&type=script&lang=js"
export * from "./TemplateMailForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports